import { MotorStatusMdl } from './MotorStatusMdl';
import { ProposalEditMdl } from './AddNewPolicyReqMdl';
export class policyModel {
  public regNo: string;
  public PolicyNo: string;
  public ProposalNo: string;
  public InsName: string;
  public IssuedDate: string;
  public PolicyFromDate: string;
  public toDate: string;
  public PolicyFileName: string;
  public PolicyCardFileName: string;
  public NPID: string;
  public NPSTATUS: string;
  public NPDESCRIPTION: string;
  public RenewalDays: string;
  public reStatus: string;
  public renewFlag: string;
  public PolicyToDate: string;
  public isEportal: string;
  public Productcode: string;
  public mypolicy: Array<PolicyInfoModel> = new Array<PolicyInfoModel>();
  public renewObj: Array<renewPolicyModel> = new Array<renewPolicyModel>();

  public PolicyStatus: string;
  public EndorsementNo: string;
  public EndorsementDate: string;
  public EndorsementDecisionDate: string;
  public EndorsementStatus: string;

  public CancellationReason: string;
  public RefundAmountExcVat: number;
  public VatOnRefundAmount: number;
  public RefundAmount: number;
  public MobileNo: string;
  public IbanNo: string;
  public BankName: string;
  public InsuredName_Ar: string;
  public InsuredName_En: string;
  public PlateNo: string;
  public UsedDays: number;
  public RemainingDays: number;
  public IsEligibleForUpgrade: string;
  public ChasissNo:string;


}
export class PolicyInfoModel {

}
export class renewPolicyModel {
  public RegNo: string;
  public PolicyNo: string;
  public NajmPolicyNo: string;
  public InsName: string;
  public Vdtype: string;
  public IqamaNo: string;
  public SequenceNo: string;
  public CustomID: string;
  public PrdCode: string;
  public OLDPolicyVDTType: string;
  public PolicyToDate: string;
  public isProposalEdit: boolean;
  public editObj: ProposalEditMdl = new ProposalEditMdl();
  public st: MotorStatusMdl = new MotorStatusMdl();
  public InsuredToken: string;
  public IqamaNoforDis: string;

}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/policyModel.ts